//@ts-ignore
import { tw } from "@careinfo/tailwind";

const Spinner = () => {
  return (
    <>
      <div className={tw`w-full relative p-3`}>
        <div
          className={tw`absolute mx-auto right-1/2 bottom-1/2  transform translate-x-1/2 translate-y-1/2`}
        >
          <div
            className={tw`border-t-transparent border-solid animate-spin  rounded-full border-primary border-4 h-8 w-8`}
          ></div>
        </div>
      </div>
    </>
  );
};

export default Spinner;
